// const API_URL = 'http://127.0.0.1:8080/api/v1';
const API_URL = 'https://dev.api.hitreview.it/api/v1';
// const API_URL = 'https://prod.api.hitreview.it/api/v1';

const MEDIA_URL = 'http://dev.media.hitreview.it';
// const MEDIA_URL = 'http://media.hitreview.it';

// const SOCKET_HOST = 'http://localhost:8080';
const SOCKET_HOST = 'https://dev.api.hitreview.it';

module.exports = {
	API_URL,
	MEDIA_URL,
	SOCKET_HOST
};
